import { ErrorStateMatcher } from "@angular/material/core";

export class DisableErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control, form) {
    return false;
  }
}